import { createContext, FC, ReactNode } from 'react'
import EntityTypeRepository from '../EntityTypeRepository'

const repository = new EntityTypeRepository()

export const EntityTypesContext = createContext<EntityTypeRepository>(repository)

interface EntityTypesProviderProps {
  children: ReactNode
}

export const EntityTypesProvider: FC<EntityTypesProviderProps> = ({ children }) => {
  return <EntityTypesContext.Provider value={repository}>{children}</EntityTypesContext.Provider>
}
